module.exports = __webpack_public_path__ + "img/logo95ABM-bco.de673dde.png";